import React, { useCallback, useEffect, useState } from 'react'
import { DemoAccountDetails } from 'api/Clients/Types/DemoAccountDetails'
import { PlatformTransactionTypeDto } from 'api/Trading-Accounts/Types/PlatformTransactionTypeDto'
import { useAppDispatch, useAppSelector } from 'store'
import { fetchInstrumentsAction } from 'store/trading-accounts/trading-accounts.actions'
import { PageQuery } from 'utils/api'
import { useApiClient } from 'utils/api/ApiClient'
import { TradingAccountsApiClient } from 'utils/api/tradingAccountsApi'
import { useFetchOneWithFetchingUpdate } from 'utils/api/useFetchOneWithFetchingUpdate'
import { isEmpty } from 'utils/is-empty'

import { DemoTradingAccountNavigation } from '../Navigation/DemoTradingAccountNavigation'
import { TradingAccountTab } from '../Navigation/TradingAccountNavigation'
import TradingAccountPlatformTransactionDetailsTable from './TradingAccountPlatformTransactionDetailsTable'

interface Props {
  data: DemoAccountDetails
}

const DemoTradingAccountPlatformTransactionDetailsPage: React.FC<Props> = ({
  data: tradingAccount,
}) => {
  const tradingAccountsApiClient = useApiClient(TradingAccountsApiClient)

  const dispatch = useAppDispatch()

  const [gridQuery, setGridQuery] = useState<PageQuery>({ pageSize: 10 })
  const [platformTransactionTypes, setPlatformTransactionTypes] = useState<
    PlatformTransactionTypeDto[]
  >([])

  const symbols = useAppSelector((state) => state.tradingAccounts.instruments)

  const fetchData = useCallback(() => {
    return tradingAccountsApiClient.getDemoTradingAccountPlatformTransaction(tradingAccount.id, {
      ...gridQuery,
      skipCount: gridQuery.skipCount ?? true,
    })
  }, [tradingAccount.id, gridQuery]) // eslint-disable-line react-hooks/exhaustive-deps
  const { data, isLoading, isFetching } = useFetchOneWithFetchingUpdate(fetchData)

  const getPlatformTransactionTypes = async () => {
    const response = await tradingAccountsApiClient.getPlatformTransactionTypes(
      tradingAccount.accountGroup.platformType.id
    )

    setPlatformTransactionTypes(response)
  }

  useEffect(() => {
    if (isEmpty(symbols)) {
      dispatch(fetchInstrumentsAction(tradingAccountsApiClient))
    }
    getPlatformTransactionTypes()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const handleGridChange = (pageQuery: PageQuery) => {
    setGridQuery(pageQuery)
  }

  return (
    <React.Fragment>
      <DemoTradingAccountNavigation
        data={tradingAccount}
        isEdit={false}
        tab={TradingAccountTab.PlatformTransactions}
      />
      <TradingAccountPlatformTransactionDetailsTable
        platformTransactionTypes={platformTransactionTypes}
        platformTransactions={data}
        gridQuery={gridQuery}
        isLoading={isLoading}
        isFetching={isFetching}
        onChange={handleGridChange}
      />
    </React.Fragment>
  )
}

export default DemoTradingAccountPlatformTransactionDetailsPage
